(() => {
  window.CaesarLLBedTrialConsistencyLoaded = true;
  const replacements = [
    [/90[\s\-‑–]*day\s+risk[\s\-‑–]*free\s+trial/gi, '90-day store-credit trial'],
    [/30[\s\-‑–]*day\s+risk[\s\-‑–]*free\s+trial/gi, '30-day store-credit trial'],
    [/Best of all\? You get 30 days to try it out\. Not in love\? We(?:’|')ll pick it up, recycle it, and give you a full refund\./gi, 'Best of all? You get 30 days to try it at home. Change-of-mind returns are issued as store credit; a 15% recycling fee and applicable shipping costs are deducted. Check the live returns terms before ordering.'],
    [/Enjoy our risk[\s\-‑–]*free 30 day Free Trial\. If for whatever reason you(?:’|')re not in love, send it back for a full refund\./gi, 'Enjoy our 30-day trial. Change-of-mind returns are issued as STORE CREDIT. A 15% recycling fee and applicable shipping costs are deducted. Read the full returns terms before ordering.']
  ];
  const skip = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);
  let observer = null;
  let observedRoot = null;
  let scheduled = false;
  function sync() {
    scheduled = false;
    if (!document.body) return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || skip.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return /risk|refund|free trial|try it/i.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      let value = node.nodeValue || '';
      const preserveAuBedTrial = window.Shopify?.country === 'AU'
        && node.parentElement?.closest('.caesar-llb-bundle-card--bed-only');
      for (const [pattern, replacement] of replacements) {
        if (preserveAuBedTrial && replacement === '30-day store-credit trial') continue;
        value = value.replace(pattern, replacement);
      }
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  function connect() {
    const root = document.documentElement;
    if (!root || root === observedRoot) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    observedRoot = root;
    schedule();
  }
  connect();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { connect(); sync(); }, { once: true });
  else sync();
  let checks = 0;
  const timer = setInterval(() => {
    connect();
    sync();
    checks += 1;
    if (checks >= 120) clearInterval(timer);
  }, 250);
})();
